export default "Zoom in to see individual pixels. Point out the highlighted center pixel — this is the pixel we're going to compute the blurred value for.\n"